var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customDepartmentResetEditItem_empty"> <div id="customDepartmentResetEditItem_empty"> <div class="modal fade" id="customDepartmentResetEditItem_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> <div class="modal-dialog modal-lg" role="document"> <div class="modal-content"> <div class="modal-header"> <h5 class="modal-title" id="exampleModalLabel">'+
((__t=( resources['X200258'] ))==null?'':__t)+
'</h5> <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </div> <div class="modal-body"> <div class="row mt-3"> <div class="col-12 grid-margin stretch-card"> <div class="card"> <div class="card-body" style="padding-bottom: 0px"> <h4 class="card-title">'+
((__t=( resources['X200258'] ))==null?'':__t)+
'</h4> <form class="contact-form"> <div class="row"> <div class="col-3 col-sm-6 col-md-3 col-xl-3"> <div class="form-group"> <label for="customDepartmentResetEditItem_select_Hour">'+
((__t=( resources['X200260'] ))==null?'':__t)+
'</label> <br> <div class="options-box"> <select class="form-control" id="customDepartmentResetEditItem_select_Hour" style="font-size:12px"> <option value="1">1</option> <option value="2">2</option> <option value="3">3</option> <option value="4">4</option> <option value="5">5</option> <option value="6">6</option> <option value="7">7</option> <option value="8">8</option> <option value="9">9</option> <option value="10">10</option> <option value="11">11</option> <option value="12">12</option> <option value="13">13</option> <option value="14">14</option> <option value="15">15</option> <option value="16">16</option> <option value="17">17</option> <option value="18">18</option> <option value="19">19</option> <option value="20">20</option> <option value="21">20</option> <option value="22">22</option> <option value="23">23</option> </select> <span class="help-inline" style="color:red"></span> </div> </div> <div class="form-group" style="margin-top: 24px"> <label for="customDepartmentResetEditItem_select_Minut">'+
((__t=( resources['X200261'] ))==null?'':__t)+
'</label> <br> <div class="options-box"> <select class="form-control" id="customDepartmentResetEditItem_select_Minut" style="font-size:12px"> <option value="0">0</option> <option value="15">15</option> <option value="30">30</option> <option value="45">45</option> <option value="8">8</option> <option value="9">9</option> <option value="0">0</option> <option value="10">10</option> <option value="11">11</option> <option value="12">12</option> <option value="13">13</option> <option value="14">14</option> <option value="15">15</option> <option value="16">16</option> <option value="17">17</option> <option value="18">18</option> <option value="19">19</option> <option value="20">20</option> <option value="21">21</option> <option value="22">22</option> <option value="23">23</option> <option value="24">24</option> <option value="25">25</option> <option value="26">26</option> <option value="27">27</option> <option value="28">28</option> <option value="29">29</option> <option value="30">30</option> <option value="31">31</option> <option value="32">32</option> <option value="33">33</option> <option value="34">34</option> <option value="35">35</option> <option value="36">36</option> <option value="37">37</option> <option value="38">38</option> <option value="39">39</option> <option value="40">40</option> <option value="41">41</option> <option value="42">42</option> <option value="43">43</option> <option value="44">44</option> <option value="45">45</option> <option value="46">46</option> <option value="47">47</option> <option value="48">48</option> <option value="49">49</option> <option value="50">50</option> <option value="51">51</option> <option value="52">52</option> <option value="53">53</option> <option value="54">54</option> <option value="55">55</option> <option value="56">56</option> <option value="57">57</option> <option value="58">58</option> <option value="59">59</option> </select> <span class="help-inline" style="color:red"></span> </div> </div>  </div> <div class="col-3 col-sm-6 col-md-3 col-xl-3"> <div class="control-group"> <div class="form-group"> <label for="customDepartmentResetEditItem_selectStatus">'+
((__t=( resources['X200257'] ))==null?'':__t)+
'</label> <br> <select name="selValue" class="selectpicker" id="customDepartmentResetEditItem_selectStatus"> <option value="0" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.Custom_Color_Default))==null?'':__t)+
';color:'+
((__t=( model.tmp.Custom_Color_Default))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.Custom_Text_Default))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.Custom_Text_Default))==null?'':__t)+
'</option> <option value="1" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.SolidColor_Color_Off))==null?'':__t)+
';color:'+
((__t=( model.tmp.SolidColor_Color_Off))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.SolidColor_Text_Off))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.SolidColor_Text_Off))==null?'':__t)+
'</option> <option value="2" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.SolidColor_Color_Busy))==null?'':__t)+
';color:'+
((__t=( model.tmp.SolidColor_Color_Busy))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.SolidColor_Text_Busy))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.SolidColor_Text_Busy))==null?'':__t)+
'</option> <option value="3" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.SolidColor_Color_Available))==null?'':__t)+
';color:'+
((__t=( model.tmp.SolidColor_Color_Available))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.SolidColor_Text_Available))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.SolidColor_Text_Available))==null?'':__t)+
'</option> <option value="4" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.SolidColor_Color_Blue))==null?'':__t)+
';color:'+
((__t=( model.tmp.SolidColor_Color_Blue))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.SolidColor_Text_Blue))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.SolidColor_Text_Blue))==null?'':__t)+
'</option> <option value="5" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.SolidColor_Color_Yellow))==null?'':__t)+
';color:'+
((__t=( model.tmp.SolidColor_Color_Yellow))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.SolidColor_Text_Yellow))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.SolidColor_Text_Yellow))==null?'':__t)+
'</option> <option value="6" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.SolidColor_Color_Cyan))==null?'':__t)+
';color:'+
((__t=( model.tmp.SolidColor_Color_Cyan))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.SolidColor_Text_Cyan))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.SolidColor_Text_Cyan))==null?'':__t)+
'</option> <option value="7" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.SolidColor_Color_Magenta))==null?'':__t)+
';color:'+
((__t=( model.tmp.SolidColor_Color_Magenta))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.SolidColor_Text_Magenta))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.SolidColor_Text_Magenta))==null?'':__t)+
'</option> <option value="8" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.SolidColor_Color_CustomColor))==null?'':__t)+
';color:'+
((__t=( model.tmp.SolidColor_Color_CustomColor))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.SolidColor_Text_CustomColor))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.SolidColor_Text_CustomColor))==null?'':__t)+
'</option> <option value="9" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.MSTeams_Color_Online))==null?'':__t)+
';color:'+
((__t=( model.tmp.MSTeams_Color_Online))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.MSTeams_Text_Online))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.MSTeams_Text_Online))==null?'':__t)+
'</option> <option value="10" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.MSTeams_Color_Busy))==null?'':__t)+
';color:'+
((__t=( model.tmp.MSTeams_Color_Busy))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.MSTeams_Text_Busy))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.MSTeams_Text_Busy))==null?'':__t)+
'</option> <option value="11" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.MSTeams_Color_DoNotDisturb))==null?'':__t)+
';color:'+
((__t=( model.tmp.MSTeams_Color_DoNotDisturb))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.MSTeams_Text_DoNotDisturb))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.MSTeams_Text_DoNotDisturb))==null?'':__t)+
'</option> <option value="12" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.MSTeams_Color_BeRightBack))==null?'':__t)+
';color:'+
((__t=( model.tmp.MSTeams_Color_BeRightBack))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.MSTeams_Text_BeRightBack))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.MSTeams_Text_BeRightBack))==null?'':__t)+
'</option> <option value="13" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.MSTeams_Color_ShowAsNotPresent))==null?'':__t)+
';color:'+
((__t=( model.tmp.MSTeams_Color_ShowAsNotPresent))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.MSTeams_Text_ShowAsNotPresent))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.MSTeams_Text_ShowAsNotPresent))==null?'':__t)+
'</option> <option value="14" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.MSTeams_Color_ShowAsOffline))==null?'':__t)+
';color:'+
((__t=( model.tmp.MSTeams_Color_ShowAsOffline))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.MSTeams_Text_ShowAsOffline))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.MSTeams_Text_ShowAsOffline))==null?'':__t)+
'</option> <option value="15" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.Mutebutton_Color_On))==null?'':__t)+
';color:'+
((__t=( model.tmp.Mutebutton_Color_On))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.Mutebutton_Text_On))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.Mutebutton_Text_On))==null?'':__t)+
'</option> <option value="16" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.Mutebutton_Color_Off))==null?'':__t)+
';color:'+
((__t=( model.tmp.Mutebutton_Color_Off))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.Mutebutton_Text_Off))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.Mutebutton_Text_Off))==null?'':__t)+
'</option> <option value="17" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.Pomodoro_Color_Time))==null?'':__t)+
';color:'+
((__t=( model.tmp.Pomodoro_Color_Time))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.Pomodoro_Text_Time))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.Pomodoro_Text_Time))==null?'':__t)+
'</option> <option value="18" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.Pomodoro_Color_ShortBreak))==null?'':__t)+
';color:'+
((__t=( model.tmp.Pomodoro_Color_ShortBreak))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.Pomodoro_Text_ShortBreak))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.Pomodoro_Text_ShortBreak))==null?'':__t)+
'</option> <option value="19" data-content="<span style=&quot;background-color:'+
((__t=( model.tmp.Pomodoro_Color_LongBreak))==null?'':__t)+
';color:'+
((__t=( model.tmp.Pomodoro_Color_LongBreak))==null?'':__t)+
';width:20px;max-width:20px;&quot; class=&quot;badge badge-success&quot;>b</span><span style=&quot;margin-left:10px;&quot; class=&quot;&quot;>'+
((__t=( model.tmp.Pomodoro_Text_LongBreak))==null?'':__t)+
'</span>">'+
((__t=( model.tmp.Pomodoro_Text_LongBreak))==null?'':__t)+
'</option> </select> </div> </div> <div class="control-group customDepartmentResetEditItem_inputText"> <div class="form-group"> <div class="control-label col-md-12"> <div class="control-group customDepartmentResetEditItem_inputText"> <div class="form-group"> <label for="customDepartmentResetEditItem_inputText">'+
((__t=( resources['X200329'] ))==null?'':__t)+
'</label> <br> <input class="form-control form-control-sm" value="'+
((__t=( model.Text))==null?'':__t)+
'" id="customDepartmentResetEditItem_inputText" maxlength="100"> <span class="help-inline" style="color:red"></span> </div> </div> </div> </div> </div> </div> </div> <div class="col-3 col-sm-6 col-md-3 col-xl-3"> <label for="customDepartmentResetEditItem_selectStatus"> </label> </div> <div class="col-3 col-sm-6 col-md-3 col-xl-3" style="display:none"> <div class="control-group customDepartmentResetEditItem_selectActiveTab"> <div class="form-group"> <label for="customDepartmentResetEditItem_selectActiveTab">'+
((__t=( resources['X200269'] ))==null?'':__t)+
'</label> <br> <select id="customDepartmentResetEditItem_selectActiveTab"> <option value="'+
((__t=( resources['X200311'] ))==null?'':__t)+
'">'+
((__t=( resources["X200311"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200270'] ))==null?'':__t)+
'">'+
((__t=( resources["X200270"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200271'] ))==null?'':__t)+
'">'+
((__t=( resources["X200271"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200272'] ))==null?'':__t)+
'">'+
((__t=( resources["X200272"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200273'] ))==null?'':__t)+
'">'+
((__t=( resources["X200273"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200274'] ))==null?'':__t)+
'">'+
((__t=( resources["X200274"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200275'] ))==null?'':__t)+
'">'+
((__t=( resources["X200275"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200276'] ))==null?'':__t)+
'">'+
((__t=( resources["X200276"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200277'] ))==null?'':__t)+
'">'+
((__t=( resources["X200277"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200278'] ))==null?'':__t)+
'">'+
((__t=( resources["X200278"] ))==null?'':__t)+
'</option> <option value="'+
((__t=( resources['X200278'] ))==null?'':__t)+
'">'+
((__t=( resources["X200312"] ))==null?'':__t)+
'</option> </select> </div> </div> </div> </form> </div> </div> </div> </div> <div class="modal-footer"> <button type="button" class="btn btn-primary btn-sm col-sm-3" id="customDepartmentResetEditItem_btnSubmit">'+
((__t=( resources['X200106'] ))==null?'':__t)+
'</button> <button type="button" class="btn btn-secondary btn-sm col-sm-3" id="customDepartmentResetEditItem_btnCancel">'+
((__t=( resources['X200110'] ))==null?'':__t)+
'</button> </div> </div> </div> </div> </div> </div> </div>';
}
return __p;
};
